"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._validator = void 0;
const is_empty_1 = require("utils/is-empty");
const _validator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let validate = {
        isError: false,
        data: initialErrorStatus
    };
    try {
        if ((0, is_empty_1.isEmpty)(arg.contractor)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { contractor: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.excavator)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { excavator: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.area)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { area: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.brand)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { brand: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.seam)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { seam: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.pit)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { pit: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.checkpoint)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { checkpoint: { status: true, message: 'Required' } })
            };
        }
        if (((_a = arg.dump_truck) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { dump_truck: { status: true, message: 'Required' } })
            };
        }
        return validate;
    }
    catch (error) {
        return {
            isError: false,
            data: initialErrorStatus
        };
    }
});
exports._validator = _validator;
const initialErrorStatus = {
    contractor: { status: false, message: 'Required' },
    excavator: { status: false, message: 'Required' },
    seam: { status: false, message: 'Required' },
    brand: { status: false, message: 'Required' },
    pit: { status: false, message: 'Required' },
    area: { status: false, message: 'Required' },
    dump_truck: { status: false, message: 'Required' },
    checkpoint: { status: false, message: 'Required' },
};
